<!-- eslint-disable vue/no-v-html -->
<template>
  <div id="chr-quickwins">
    <div
      id="printTitleAndDescription"
      class="tw-flex tw-items-start tw-self-stretch"
    >
      <div
        class="tw-flex tw-flex-col tw-justify-between tw-gap-[12px] tw-pb-[40px] tw-w-[100%] tw-break-inside-avoid"
      >
        <div class="tw-w-[100%]">
          <div
            id="chr-sheading-quickwins"
            class="tw-text-[#211F58] tw-text-[24px] tw-font-semibold tw-w-fit"
          >
            {{
              getComponentUiText("app-share-cyber-profile-quick-wins-title-1")
            }}
          </div>
        </div>
        <div
          class="tw-text-[#231F20] tw-text-[14px] tw-font-normal lg:tw-w-[50%] tw-opacity-[0.7]"
        >
          {{
            getComponentUiText("app-share-cyber-profile-quick-wins-sub-title-1")
          }}
        </div>
        <div class="tw-text-[#387DFF] tw-text-[14px] tw-font-normal">
          <p
            class="tw-m-[0px] tw-cursor-pointer tw-w-fit"
            @click="openRecommendPage"
          >
            {{
              getComponentUiText(
                "app-share-cyber-profile-quick-wins-view-all-recommend-button-title-1",
              )
            }}
          </p>
        </div>
      </div>
      <div
        v-if="customTableData?.length > 0 && isEdit"
        class="tw-h-[44px] tw-mr-[20px] tw-relative tw-flex tw-items-center tw-flex-wrap"
      >
        <TextInputWithArrow
          :max="maxPaging"
          :paging="paging || maxPaging || 5"
          :type="localStorageKey.sharingPagingQuickwin"
          :custom-input-class="'tw-text-[14px]'"
          @arrow-click="handleArrowClick"
        />
      </div>
      <div
        v-if="isEnableEdit"
        id="pen-icon-incidents"
        :class="isEdit ? 'is_editable' : 'not_editable'"
        class="header__pen"
        @click="editNotes"
      >
        <Pen :color="isEdit ? '#ffffff' : '#387DFF'" />
      </div>
    </div>
    <div v-if="!isLoading" class="quickwin-table tw-overflow-auto">
      <div
        v-if="customTableData.length"
        id="recommendPdfParent"
        class="tw-flex tw-flex-col tw-rounded-[6px] tw-w-[1500px] tw-gap-[20px]"
      >
        <div
          v-for="(item, index) in customTableData"
          :key="item.id"
          :data-cy="`quick-wins-list`"
          :class="{ 'first-item': index === 0 }"
          class="tw-flex tw-p-[40px] tw-items-center tw-self-stretch recommend-item"
        >
          <div
            class="tw-flex tw-justify-center tw-items-center tw-w-[160px] tw-min-w-[160px] tw-h-[111px] tw-mr-[32px] tw-bg-[#d9edff] tw-rounded-[6px]"
          >
            <img
              v-if="!item.checklistGroupImage"
              src="@/assets/img/recommend-icon.svg"
            />
            <img
              v-else
              :src="item.checklistGroupImage"
              class="tw-max-w-[96px]"
            />
          </div>
          <div
            id="recommendPdf"
            :class="`tw-w-full tw-flex tw-flex-row tw-justify-between`"
          >
            <div
              :class="`tw-flex tw-gap-[12px] tw-w-[358px] tw-flex-col`"
              style="overflow-wrap: anywhere"
            >
              <div
                class="tw-flex tw-justify-between tw-items-start tw-text-[20px] tw-text-[#211F58] tw-font-semibold"
              >
                <span
                  v-if="!isEdit"
                  class="tw-flex-1"
                  v-html="
                    `${item.index}. ${item.checklistGroupName?.replace(
                      /\n/g,
                      '<br>',
                    )}`
                  "
                />
                <div
                  v-else
                  class="tw-flex tw-flex-col tw-w-full tw-relative tw-justify-start"
                >
                  <textarea
                    ref="checklistGroupNameRef"
                    v-model="item.checklistGroupName"
                    :class="`tw-bg-[#eff0f180] tw-p-[12px] ${
                      isCallApi &&
                      isUpdateName &&
                      idUpdateItem === item.checklistGroupId
                        ? 'tw-pr-[45px]'
                        : ''
                    } tw-text-[16px] tw-font-[400] tw-text-[#231F20] tw-overflow-hidden ${
                      itemInvalids.includes(item.checklistGroupId)
                        ? 'tw-border-[red] tw-outline-none '
                        : 'tw-border-[#EFF0F1]  tw-outline-[#EFF0F1]'
                    } tw-border-solid tw-border tw-rounded-md`"
                    rows="1"
                    type="text"
                    @focus="
                      () => {
                        if (item.checklistGroupName)
                          item.oldName = item.checklistGroupName;
                      }
                    "
                    @input="
                      (e: any) => {
                        onresizeTextarea(checklistGroupNameRef, index);
                        const idxValid = itemInvalids.indexOf(
                          item.checklistGroupId,
                        );
                        if (e.target.value && idxValid !== -1) {
                          itemInvalids.splice(idxValid, 1);
                          item.checklistGroupName = e.target.value;
                        }
                      }
                    "
                    @blur="
                      async (e: any) => {
                        isUpdateName = true;
                        isUpdateActions = false;
                        isUpdateDescription = false;
                        const value = e.target.value.trim();
                        if (item.oldName === value || !value) {
                          if (!value) {
                            itemInvalids.push(item.checklistGroupId);
                            item.checklistGroupName = '';
                          }
                          return;
                        }
                        const idxValid = itemInvalids.indexOf(
                          item.checklistGroupId,
                        );
                        if (idxValid !== -1) {
                          itemInvalids.splice(idxValid, 1);
                        }
                        const res = await updateChecklistGroup(
                          {
                            checklistGroupId: item.checklistGroupId,
                            name: value,
                          },
                          item,
                        );
                        item.checklistGroupName = res ? res.name : item.oldName;
                      }
                    "
                  />
                  <div
                    v-if="
                      isCallApi &&
                      isUpdateName &&
                      idUpdateItem === item.checklistGroupId
                    "
                    class="tw-h-[35px] tw-w-[35px] tw-absolute tw-right-[12px]"
                  >
                    <!-- eslint-disable vue/no-unused-refs -->
                    <LottieAnimation
                      ref="anim"
                      :animation-data="ProgressAnimation"
                      :auto-play="true"
                      :loop="true"
                    />
                  </div>
                  <span
                    v-if="
                      isEdit && itemInvalids.includes(item.checklistGroupId)
                    "
                    class="tw-text-[#f7553c] tw-font-[500] tw-text-[11px] tw-leading-[130%] tw-mt-[3px]"
                    >{{
                      getComponentUiText(
                        "app-common-form-value-required-error-1",
                      )
                    }}</span
                  >
                </div>
                <div
                  v-if="item.checklistGroupCompletionPcnt !== null"
                  class="tw-flex tw-items-center tw-pt-[4px] tw-ml-6"
                >
                  <AssessmentChecklistStatusTag
                    v-if="item.checklistGroupCompletionPcnt !== null"
                    class="tw-flex-1"
                    :checklist-status="
                      item.checklistGroupCompletionPcnt === 1
                        ? getComponentUiText(
                            'app-component-assessments-checklists-assessment-details-card-status-3',
                          )
                        : item.checklistGroupCompletionPcnt > 0 &&
                            item.checklistGroupCompletionPcnt < 1
                          ? getComponentUiText(
                              'app-component-assessments-checklists-assessment-details-card-status-1',
                            )
                          : getComponentUiText(
                              'app-component-assessments-checklists-assessment-details-card-status-2',
                            )
                    "
                    :checklist-status-id="
                      item.checklistGroupCompletionPcnt === 1
                        ? CHECKLISTSTATUS.DONE
                        : item.checklistGroupCompletionPcnt > 0 &&
                            item.checklistGroupCompletionPcnt < 1
                          ? CHECKLISTSTATUS.INPROG
                          : CHECKLISTSTATUS.NEW
                    "
                    :is-loading="false"
                  />
                </div>
              </div>
              <div
                v-if="item.checklistGroupDescription || isEdit"
                class="tw-text-[16px] tw-text-[#231F20] tw-font-normal tw-leading-[150%]"
              >
                <customDescriptionContent
                  v-if="!isEdit"
                  :description="
                    item.checklistGroupDescription?.replace(/\n/g, '<br>')
                  "
                  :class-line="'tw-text-base tw-font-normal tw-leading-6 tw-text-[#231F20]'"
                  :custom-class="'!tw-p-0'"
                ></customDescriptionContent>
                <div v-else class="tw-relative tw-flex tw-items-start">
                  <Textarea
                    ref="checklistGroupDescriptionRef"
                    v-model="item.checklistGroupDescription"
                    :style="`outline-color : #EFF0F1`"
                    :value="item.checklistGroupDescription"
                    :class="`${
                      isCallApi &&
                      isUpdateDescription &&
                      idUpdateItem === item.checklistGroupId
                        ? 'tw-pr-[45px]'
                        : ''
                    }`"
                    class="tw-bg-[#eff0f180] tw-overflow-hidden tw-w-full tw-p-[12px] tw-text-[16px] tw-font-[400] tw-text-[#231F20] tw-border-[#EFF0F1] tw-border-solid tw-border tw-rounded-md"
                    type="text"
                    rows="1"
                    @input="
                      onresizeTextarea(checklistGroupDescriptionRef, index)
                    "
                    @focus="
                      () => {
                        if (item.checklistGroupDescription)
                          item.oldChecklistGroupDescription =
                            item.checklistGroupDescription;
                      }
                    "
                    @blur="
                      async (e: any) => {
                        isUpdateDescription = true;
                        isUpdateName = false;
                        isUpdateActions = false;

                        const value = e.target.value.trim();
                        if (item.oldChecklistGroupDescription === value) {
                          return;
                        }
                        item.checklistGroupDescription = value;
                        const res = await updateChecklistGroup(
                          {
                            checklistGroupId: item.checklistGroupId,
                            description: value,
                          },
                          item,
                        );
                        item.checklistGroupDescription = res
                          ? res.description
                          : item.oldChecklistGroupDescription;
                      }
                    "
                  />

                  <div
                    v-if="
                      isCallApi &&
                      isUpdateDescription &&
                      idUpdateItem === item.checklistGroupId
                    "
                    class="tw-h-[35px] tw-w-[35px] tw-absolute tw-right-[12px]"
                  >
                    <!-- eslint-disable vue/no-unused-refs -->
                    <LottieAnimation
                      ref="anim"
                      :animation-data="ProgressAnimation"
                      :auto-play="true"
                      :loop="true"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div :class="`tw-flex tw-gap-[12px] tw-flex-col tw-w-[403px]`">
              <div class="tw-text-[20px] tw-text-[#211F58] tw-font-semibold">
                <span>
                  {{
                    getComponentUiText(
                      "app-share-cyber-profile-quick-wins-how-header-title-1",
                    )
                  }}</span
                >
              </div>
              <div
                class="tw-text-[14px] tw-text-[#231F20] tw-font-normal tw-leading-[150%]"
                style="overflow-wrap: anywhere"
              >
                <span
                  v-if="!isEdit"
                  v-html="item.checklistGroupActions?.replace(/\n/g, '<br>')"
                />
                <div v-else class="tw-relative tw-flex tw-items-start">
                  <Textarea
                    ref="checklistGroupActionsRef"
                    v-model="item.checklistGroupActions"
                    :style="`outline-color : #EFF0F1`"
                    :class="`${
                      isCallApi &&
                      isUpdateActions &&
                      idUpdateItem === item.checklistGroupId
                        ? 'tw-pr-[45px]'
                        : ''
                    }`"
                    class="tw-bg-[#eff0f180] tw-w-full tw-overflow-hidden tw-p-[12px] tw-text-[16px] tw-font-[400] tw-text-[#231F20] tw-border-[#EFF0F1] tw-border-solid tw-border tw-rounded-md"
                    :value="item.checklistGroupActions"
                    rows="1"
                    type="text"
                    @focus="
                      () => {
                        if (item.checklistGroupActions)
                          item.oldChecklistGroupActions =
                            item.checklistGroupActions;
                      }
                    "
                    @input="onresizeTextarea(checklistGroupActionsRef, index)"
                    @blur="
                      async (e: any) => {
                        isUpdateActions = true;
                        isUpdateName = false;
                        isUpdateDescription = false;
                        const value = e.target.value.trim();
                        if (
                          item.oldChecklistGroupActions === value ||
                          (item.checklistGroupActions === null && value === '')
                        ) {
                          return;
                        }
                        item.checklistGroupActions = value;
                        const res = await updateChecklistGroup(
                          {
                            checklistGroupId: item.checklistGroupId,
                            actions: value,
                          },
                          item,
                        );
                        item.checklistGroupActions = res
                          ? res.actions
                          : item.oldChecklistGroupActions;
                      }
                    "
                  />
                  <div
                    v-if="
                      isCallApi &&
                      isUpdateActions &&
                      idUpdateItem === item.checklistGroupId
                    "
                    class="tw-h-[35px] tw-w-[35px] tw-absolute tw-right-[12px]"
                  >
                    <!-- eslint-disable vue/no-unused-refs -->
                    <LottieAnimation
                      ref="anim"
                      :animation-data="ProgressAnimation"
                      :auto-play="true"
                      :loop="true"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div :class="`tw-flex tw-gap-[20px] tw-items-center`">
              <div class="quality-group tw-h-[45px]">
                <div class="tw-text-[14px] tw-text-[#211F58] tw-font-semibold">
                  {{
                    getComponentUiText(
                      "app-share-cyber-profile-roadmap-table-importance-header-title-1",
                    )
                  }}
                </div>
                <QualityAssessment
                  :data="item.checklistGroupBang"
                  :type="QUALITY_ASSESSMENT_TYPE.IMPORTANCE"
                ></QualityAssessment>
              </div>
              <div class="quality-group tw-h-[45px]">
                <div class="tw-text-[14px] tw-text-[#211F58] tw-font-semibold">
                  {{
                    getComponentUiText(
                      "app-share-cyber-profile-roadmap-table-cost-header-title-1",
                    )
                  }}
                </div>
                <QualityAssessment
                  :data="item.checklistGroupBuck"
                  :type="QUALITY_ASSESSMENT_TYPE.COST"
                ></QualityAssessment>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!customTableData.length" class="tw-overflow-auto">
        <div
          id="recommendPdfParent"
          class="tw-flex tw-flex-col tw-rounded-[6px] tw-w-[1500px] tw-gap-[20px]"
        >
          <div
            data-cy="quick-wins-empty-list"
            class="tw-flex tw-p-[40px] tw-items-center tw-self-stretch recommend-item"
          >
            <div
              class="tw-h-[110px] tw-w-[100%] tw-flex tw-justify-center tw-items-center tw-text-[#878787] tw-text-[14px]"
            >
              {{
                getComponentUiText(
                  "app-share-cyber-profile-quick-wins-empty-list-title-1",
                )
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isLoading" class="tw-overflow-auto">
      <div
        class="tw-flex tw-flex-col tw-rounded-[6px] tw-w-[1500px] tw-gap-[20px]"
      >
        <div
          class="tw-flex tw-p-[40px] tw-items-center tw-self-stretch recommend-item"
        >
          <div
            class="custom-global-skeleton-pulse tw-h-[110px] tw-w-[100%] tw-rounded-[6px]"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import TextInputWithArrow from "@/components/share/textInputWithArrow.vue";
import { getComponentUiText, parseDescription } from "@/utils/utilities";
import { computed, nextTick, ref, Ref, watch } from "vue";
import QualityAssessment from "./qualityAssessment.vue";
import router from "@/router";
import store from "@/store";
import AssessmentChecklistStatusTag from "@/components/assessment/assessmentChecklistStatusTag.vue";
import {
  CHECKLISTSTATUS,
  localStorageKey,
  QUALITY_ASSESSMENT_TYPE,
} from "@/utils/constants";
import Pen from "@/components/svgs/pen.vue";
import customDescriptionContent from "@/components/common/customDescriptionContent.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Checklist } from "@/services/apiRoutes/routes";
import { putChecklistGroup } from "@/services/recommend";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "@/assets/animation/progress_light.json";
import { exceptionStatusCodes } from "../../utils/constants";

const props = defineProps({
  isEdit: {
    type: Boolean,
    default: false,
  },
  isEnableEdit: {
    type: Boolean,
    default: true,
  },
  rootChecklistReportId: {
    type: Number,
    default: 0,
  },
});
const itemInvalids: any = ref([]);
const checklistGroupNameRef = ref(null);
const checklistGroupDescriptionRef = ref(null);
const checklistGroupActionsRef = ref(null);
const isCallApi = ref(false);
const idUpdateItem = ref(0);
const isUpdateName = ref(false);
const isUpdateActions = ref(false);
const isUpdateDescription = ref(false);

const onresizeTextarea = (ref, index) => {
  nextTick(() => {
    if (!ref || !ref[index]) {
      return;
    }
    const textarea = ref[index];
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  });
};

const handleArrowClick = ({ value }) => {
  paging.value = value;

  if (!props.rootChecklistReportId || props.rootChecklistReportId === 0) return;

  const localData = JSON.parse(
    localStorage.getItem(localStorageKey.sharingPagingQuickwin) || "{}",
  );

  localData[props.rootChecklistReportId] = value;

  localStorage.setItem(
    localStorageKey.sharingPagingQuickwin,
    JSON.stringify(localData),
  );
};

watch(
  () => props.isEdit,
  (newVal) => {
    if (newVal) {
      nextTick(() => {
        const checklistGroupNameRefs = checklistGroupNameRef.value;
        if (checklistGroupNameRefs && checklistGroupNameRefs.length) {
          checklistGroupNameRefs.forEach((ref, index) => {
            onresizeTextarea(checklistGroupNameRefs, index);
          });
        }
        const checklistGroupDescriptionRefs =
          checklistGroupDescriptionRef.value;
        if (
          checklistGroupDescriptionRefs &&
          checklistGroupDescriptionRefs.length
        ) {
          checklistGroupDescriptionRefs.forEach((ref, index) => {
            onresizeTextarea(checklistGroupDescriptionRefs, index);
          });
        }
        const checklistGroupActionsRefs = checklistGroupActionsRef.value;
        if (checklistGroupActionsRefs && checklistGroupActionsRefs.length) {
          checklistGroupActionsRefs.forEach((ref, index) => {
            onresizeTextarea(checklistGroupActionsRefs, index);
          });
        }
      });
    }
  },
);
const emit = defineEmits([
  "update-hover-title",
  "on-update-input",
  "update-edit-title",
  "on-click-edit",
  "update:edit",
  "on-form-invalid",
]);
const editNotes = () => {
  if (itemInvalids.value.length) {
    return;
  }
  emit("update:edit", !props.isEdit);
};
watch(
  () => itemInvalids.value,
  (newVal) => {
    if (itemInvalids.value.length) {
      emit("on-form-invalid", true);
    } else {
      emit("on-form-invalid", false);
    }
  },
  { deep: true },
);
const updateChecklistGroup = async (param, item) => {
  idUpdateItem.value = item.checklistGroupId;
  try {
    isCallApi.value = true;
    if (param.checklistGroupId) {
      const params = {
        checklistId: store.getters["Sharing/getChecklistReportId"],
        ...param,
      };
      const res = await putChecklistGroup(params);
      return res.data.data;
    }
  } catch (error) {
    const extendText = getComponentUiText(
      "app-share-cyber-profile-extend-error-messages-1",
      false,
      {
        name: getComponentUiText(
          "app-share-cyber-profile-display-option-quick-wins-1",
        ),
      },
    );
    showErrorAPI(
      error,
      Checklist.updateChecklistItemGroup,
      exceptionStatusCodes.BadGateway,
      extendText,
    );
    return null;
  } finally {
    setTimeout(() => {
      isCallApi.value = false;
      isUpdateName.value = false;
      isUpdateActions.value = false;
      isUpdateDescription.value = false;
    }, 1000);
  }
};

const maxPaging = computed(() => {
  const data = store.getters["Sharing/getChecklistQuickWin"];
  return data && data.length ? data.length : 0;
});

const paging: Ref<any> = ref(5);

const getPagingValue = () => {
  const localData = JSON.parse(
    localStorage.getItem(localStorageKey.sharingPagingQuickwin) || "{}",
  );

  if (!props.rootChecklistReportId || props.rootChecklistReportId === 0)
    return maxPaging.value;

  if (localData[props.rootChecklistReportId]) {
    const value = Number(localData[props.rootChecklistReportId]);
    return value > maxPaging.value ? maxPaging.value : value;
  }

  return maxPaging.value;
};

watch(
  () => maxPaging.value,
  (newVal) => {
    maxPaging.value && (paging.value = getPagingValue());
  },
);
const customTableData = computed(() => {
  const data = store.getters["Sharing/getChecklistQuickWin"];
  data &&
    data.length &&
    data.forEach((group) => {
      const { checklistGroupImage, checklistGroupDescription } =
        parseDescription(group);
      group.checklistGroupImage = checklistGroupImage;
      group.checklistGroupDescription = checklistGroupDescription;
      return group;
    });

  if (
    !data ||
    !data.length ||
    !paging.value ||
    typeof paging.value !== "number"
  )
    return [];

  return !paging.value ? data : data.slice(0, Number(paging.value) || 5);
});

const isLoading: Ref<any> = computed(() => {
  return store.state.Sharing.loadingSplit[
    Checklist.getChecklistReportDataActions
  ];
});

const openRecommendPage = () => {
  router.push("/assess/roadmap");
};
</script>

<style lang="scss" scoped>
.recommend-item {
  border: 1px solid var(--UI-rule, #eff0f1);
  background: var(--UI-white, #ffffff);
  border-radius: 6px;
  break-inside: avoid !important;
}
.quality-group {
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 12px 20px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  border: 1px solid var(--UI-rule, #eff0f1);
  background: var(--UI-row-bg, #fcfcfd);
}

.is_editable {
  cursor: pointer;
  background: var(--Brand-Navy, #211f58);
}
.not_editable {
  cursor: pointer;
  background: var(--UI-white, #fff);
}
.header__pen {
  border-radius: 6px;
  border: 1px solid var(--UI-rule, #eff0f1);
  padding: 9px 14px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  width: 46px;
  height: 44px;
}
:deep(.table-header) {
  background-color: #211f58 !important;
}

@media print {
  #recommendPdfParent {
    // padding-bottom: 50px;
    width: 100%;
  }
  #printTitleAndDescription {
    page-break-after: avoid;
  }

  .first-item {
    page-break-before: avoid;
  }

  #printTitleAndDescription,
  .first-item {
    break-inside: avoid;
  }
  #recommendPdf {
    display: flex;
    justify-content: space-between;
  }
  #pen-icon-incidents {
    display: none;
  }
  .quickwin-table {
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
